// extracted by mini-css-extract-plugin
export default {"canvas":"styles_canvas__W68Ck","overlay":"styles_overlay__F4WDJ","ready":"styles_ready__9z3YA","container":"styles_container__577pf"};